<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		height: string;
		width: string;
		borderRadius?: string;
		class?: ClassValue;
	}

	const {
		height,
		width,
		borderRadius = '9999px',
		class: classes,
	}: Props = $props();

</script>

<div
	class={['bg-neutral-soft b-rounded-full', classes]}
	style="--width:{width}; --height:{height}; --border-radius:{borderRadius}"
></div>

<style>
	div {
		border-radius: var(--border-radius);
		width: var(--width);
		height: var(--height);
	}
</style>
